<template lang="html">
  <div class="">
    <Container
      lock-axis="y"
      class="flex pa-0"
      drag-handle-selector=".si-drag-handle"
      @drop="onDropSection"
    >
      <Draggable
        v-for="(section, i) in sortredinternalSections"
        :key="i"
      >
        <v-container
          grid-list-md
          fluid
          ma-0
          pa-0
        >
          <v-layout ma-0>
            <v-flex xs12>
              <v-card
                :id="section.id"
                :ref="section.id"
                outlined
              >
                <v-layout
                  align-center
                  fill-height
                  ma-0
                  pa-2
                >
                  <v-icon class="cursor-move si-drag-handle">
                    drag_indicator
                  </v-icon>
                  <SiConditionEditor
                    v-model="section.condition"
                    :title="`<strong>${section.title}</strong> condition`"
                    :fields="fields"
                    @input="save"
                  />
                  <v-flex
                    shrink
                    pa-0
                    pr-2
                  >
                    <div>
                      <span
                        :class="{'grey--text font-italic': !section.title}"
                        class=" font-weight-boldxx title"
                      >{{ section.title || 'new section' }}</span> <span class="grey--text ml-2">{{ section.id }}</span>
                    </div>
                    <div class="caption">
                      {{ section.description }}
                    </div>
                  </v-flex>
                  <v-spacer />
                  <v-btn
                    text
                    color="grey"
                    @click="openPanel('panels', section.id)"
                  >
                    {{ panels[section.id] === 0 ? 'Done' : 'Edit' }}
                  </v-btn>
                </v-layout>

                <v-expansion-panels
                  v-model="panels[section.id]"
                  class="si-expansion-panel-flat"
                >
                  <v-expansion-panel expand-icon="edit">
                    <v-expansion-panel-content>
                      <v-container grid-list-md>
                        <v-flex
                          xs12
                          mb-3
                        >
                          <v-layout
                            ma-0
                            align-center
                          >
                            <SiConditionEditor
                              v-model="section.condition"
                              :title="`<strong>${section.title}</strong> condition`"
                              :fields="fields"
                              @input="save"
                            >
                              <template
                                v-if="!section.condition"
                                #activator="{ on }"
                              >
                                <v-btn
                                  text
                                  color="grey"
                                  v-on="on"
                                >
                                  <v-icon left>
                                    arrow_upward
                                  </v-icon>no conditions
                                </v-btn>
                              </template>
                            </SiConditionEditor>
                            <SiConditionChips :condition="section.condition" />
                          </v-layout>
                        </v-flex>
                        <v-flex xs12>
                          <SiInputText
                            :ref="`${section.id}_title`"
                            v-model="section.title"
                            outlined
                            autofocus
                            hide-details
                            label="Section title"
                            @input="autosave(section.id)"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <SiInputTextarea
                            v-model="section.description"
                            outlined
                            auto-grow
                            rows="2"
                            hide-details
                            label="Section description"
                            @input="autosave(section.id)"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <SiInputTextarea
                            v-model="section.help"
                            outlined
                            auto-grow
                            rows="2"
                            hide-details
                            label="Section help"
                            @input="autosave(section.id)"
                          />
                        </v-flex>
                        <v-layout justify-center>
                          <SiDeleteButton
                            title="Delete Section?"
                            :message="`Are you certain you want to delete section id <strong>${section.id}</strong>? If this section is used in a calculation, deleting it will cause the calculation to fail. <br> <br> <strong> IMPORTANT: </strong> Ensure this section id is not used in code before deleteing.`"
                            :challenge="section.id"
                            @delete="deleteSection(section.id)"
                          >
                            <template #activator="{ on }">
                              <v-btn
                                text
                                color="grey"
                                v-on="on"
                              >
                                Delete Section
                              </v-btn>
                            </template>
                          </SiDeleteButton>
                        </v-layout>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout :align-center="panelFields[section.id] !== 0">
            <v-flex shrink>
              <v-btn
                text
                small
                icon
                color="grey"
                @click="openPanel('panelFields', section.id)"
              >
                <v-icon>{{ panelFields[section.id] === 0 ? 'expand_less' : 'expand_more' }}</v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-expansion-panels
                v-model="panelFields[section.id]"
                class="si-expansion-panel-flat"
              >
                <v-expansion-panel
                  expand-icon=""
                  class="transparent"
                >
                  <v-expansion-panel-content>
                    <v-layout
                      mx-n6
                      my-0
                    >
                      <v-flex pa-0>
                        <SiFieldListEditor
                          v-model="section.fields"
                          :fields="fields"
                          :all-picked-fields="allPickedFields"
                          :highlight-field="$route.query.fieldName"
                          @input="save"
                        />
                      </v-flex>
                    </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <template v-if="panelFields[section.id] !== 0">
                <v-layout align-center>
                  <v-divider class="mx-2" />
                  <v-flex
                    v-if="panelFields[section.id] !== 0"
                    shrink
                    px-3
                  >
                    {{ (section.fields || []).length }} {{ `${(section.fields || []).length > 1 ? 'fields' : 'field'}` }}
                  </v-flex>
                  <v-divider class="mx-2" />
                </v-layout>
              </template>
            </v-flex>
          </v-layout>
        </v-container>
      </Draggable>
    </Container>
   
    <v-layout
      align-center
      mb-5
      ma-0
    >
      <v-flex xs12>
        <SiVariableEditor
          variable-term="section name"
          prefix="section_"
          :existing-variables="sectionsAll"
          divider-right
          @variable="addSection"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import { forEach } from 'lodash'
import helpers from '@/mixins/helpers'
import firebase from '@/mixins/firebase'
import { rtdb } from '@/plugins/firebase'
import drag from '@/mixins/drag'
import conditions from '@/mixins/conditions'
import autosave from '@/mixins/autosave'

export default {
  components: { Container, Draggable },
  mixins: [ helpers, drag, firebase, conditions, autosave ],
  props: {
    fields: Object,
    initialSection: Object,
    sections: Object,
    sectionsAll: Object,
    mapping: Object,
    calculatorId: String,
    savePath: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      // fieldList: this.pickedFields,
      panelFields: {},
      panels: {},
      internalSections: this.sections,
      newSection: false,
      newSectionName: ''
    }
  },
  computed: {
    sortredinternalSections: {
      get () {
        return this._sortObject(this.internalSections)
      },
      set (v) {
        v.forEach((section, i) => {
          section.index = i
        })
        this.internalSections = this._unSortObject(v)
      }
    },
    allPickedFields () {
      var picked = []
      forEach(this.sectionsAll, section => {
        picked = picked.concat(section.fields)
      })
      return picked.concat(this.inMulti)
    },
    inMulti () {
      var inMulti = []
      forEach(this.fields, f => {
        inMulti = inMulti.concat(f.fields) || []
      })
      return inMulti.filter(x => {
        return x
      })
    }
  },
  watch: {
    sections (v) {
      this.internalSections = v
      forEach(v, (section, sectionId) => {
        if (!this.panelFields[sectionId]) this.$set(this.panelFields, sectionId, 0)
      })
    }
  },
  mounted () {
    forEach(this.sections, (section, sectionId) => {
      this.$set(this.panelFields, sectionId, 0)
    })
  },
  methods: {
    openPanel (panel, sectionId) {
      if (this[panel][sectionId] === 0) {
        this[panel][sectionId] = -1
      } else {
        this.$set(this[panel], sectionId, 0)
      }
    },
    addSection (name) {
      let section = {
        id: name,
        index: (this.sortredinternalSections || []).length
      }
      rtdb.ref(`${this.savePath}/${name}`).set(section)
      this.$set(this.panels, name, 0)
      this.$set(this.panelFields, name, 0)

      setTimeout(() => {
        this.$refs[`${name}_title`][0].focus()
        this.$vuetify.goTo(`#${name}`)
        // this.newSection = false
      }, 300)
    },
    deleteSection (sectionId) {
      rtdb.ref(`${this.savePath}/${sectionId}`).remove()
    },
    autosave (sectionId) {
      delete this.internalSections[sectionId].new
      this._autosave(`${this.savePath}/${sectionId}`, this.internalSections[sectionId], 500)
    },
    save () {
      this._autosave(this.savePath, this.internalSections, 0)
    },
    onDropSection (e) {
      this.sortredinternalSections = this._applyDrag(this.sortredinternalSections, e)
      this.sortredinternalSections.forEach((section, i) => {
        section.index = i
      })
      this.save()
    }
  }
}
</script>

<style lang="css" scoped>
.flip-horiz{
  -moz-transform: scale(-1, 1);
  -webkit-transform: scale(-1, 1);
  -o-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
  transform: scale(-1, 1);
}
</style>
